import { useState } from 'react';
import classNames from 'classnames';
import bankInitials from '../../utils/bankInitials';

interface BankLogoProps {
  bank: string;
  logoUrl?: string | null;
  size?: 'sm' | 'md';
}

/**
 * Logo del banco de una promoción. Sin logo cargado (o si no carga) va un
 * monograma con las iniciales, para que la promo se reconozca igual.
 */
const BankLogo = ({ bank, logoUrl, size = 'sm' }: BankLogoProps) => {
  const [failed, setFailed] = useState(false);
  const box = size === 'sm' ? 'h-7 w-7 text-[11px]' : 'h-10 w-10 text-sm';
  if (logoUrl && !failed) {
    return (
      <img
        src={logoUrl}
        alt=""
        className={classNames(box, 'shrink-0 rounded-full bg-surface-base object-contain')}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span aria-hidden className={classNames(box, 'flex shrink-0 items-center justify-center rounded-full bg-primary-500 font-bold text-white')}>
      {bankInitials(bank)}
    </span>
  );
};

export default BankLogo;
